module.exports = __webpack_public_path__ + "static/media/uva.84a2083d.png";